"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeysPopupCommunicator = void 0;
const version_1 = require("../../version");
const PopUpCommunicator_1 = require("./PopUpCommunicator");
const constants_1 = require("../constants");
const error_1 = require("../error");
class KeysPopupCommunicator {
    constructor(url = constants_1.CB_KEYS_URL) {
        this.listeners = new Map();
        this.popup = null;
        this.url = new URL(url);
    }
    async postMessage(request) {
        const popup = await this.waitForPopupLoaded();
        popup.postMessage(request, this.url.origin);
        const { id } = request;
        if (!id)
            return {}; // do not wait for response if no id
        return this.onMessage(({ requestId }) => requestId === id);
    }
    async onMessage(predicate) {
        return new Promise((resolve, reject) => {
            const listener = (event) => {
                if (event.origin !== this.url.origin)
                    return; // origin validation
                const message = event.data;
                if (predicate(message)) {
                    resolve(message);
                    window.removeEventListener('message', listener);
                    this.listeners.delete(listener);
                }
            };
            window.addEventListener('message', listener);
            this.listeners.set(listener, { reject });
        });
    }
    rejectPendingListeners() {
        this.listeners.forEach(({ reject }, listener) => {
            reject(error_1.standardErrors.provider.userRejectedRequest('Request rejected'));
            window.removeEventListener('message', listener);
        });
        this.listeners.clear();
    }
    async waitForPopupLoaded() {
        if (this.popup)
            return this.popup;
        this.popup = (0, PopUpCommunicator_1.openPopup)(this.url);
        this.onMessage(({ event }) => event === 'PopupUnload').then(() => {
            (0, PopUpCommunicator_1.closePopup)(this.popup);
            this.popup = null;
            this.rejectPendingListeners();
        });
        return this.onMessage(({ event }) => event === 'PopupLoaded')
            .then((message) => {
            this.postMessage({
                requestId: message.id,
                data: { version: version_1.LIB_VERSION },
            });
        })
            .then(() => {
            if (!this.popup)
                throw error_1.standardErrors.rpc.internal();
            return this.popup;
        });
    }
}
exports.KeysPopupCommunicator = KeysPopupCommunicator;
